import { memo } from 'react';
import { useCalendar, useLocale } from 'react-aria';
import { useCalendarState } from 'react-stately';
import { createCalendar } from '@internationalized/date';
import { Button } from 'react-aria-components';
import type { AriaCalendarProps, DateValue } from 'react-aria';
import CalendarGrid from '@components/calendar/CalendarGrid';
import nextButton from '@assets/icons/calendar-next-icon.svg';
import previousButton from '@assets/icons/calendar-previous-icon.svg';



type CalendarProps<T extends DateValue> = AriaCalendarProps<T>;


const Calendar = <T extends DateValue>(props: CalendarProps<T>): JSX.Element => {

	let { locale } = useLocale();
	let state = useCalendarState({ ...props, locale, createCalendar });
	let { calendarProps, prevButtonProps, nextButtonProps, title } = useCalendar(props, state);

	return (
		<div {...calendarProps} className='component-calendar'>
			
			<div className='calendar-header'>
				
				<h2>{title}</h2>
				
				<Button {...prevButtonProps} className='calendar-switch-button disable-selection'>
					<img src={previousButton} alt='calendar-previous-icon' className='disable-selection' draggable={false} />
				</Button>
				
				<Button {...nextButtonProps} className='calendar-switch-button disable-selection'>
					<img src={nextButton} alt='calendar-next-icon' className='disable-selection' draggable={false} />
				</Button>
			
			</div>
			
			<CalendarGrid state={state} />
		</div>
	)
}

export default memo(Calendar);